import { Component } from '@angular/core';
import { UpdateUserRequest } from '@dto/updateUserRequest';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { DtoService } from '@services/dto/dto.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {

  constructor(private dtoService: DtoService, private authenticationService: AuthenticationService) { }
}
